<template>
    <div ref='game-screen' class='game-screen' :class='{ ready: isReady }'>
        <ScreenMenu>
            <button class="stop-button" v-on:click="stopGame">STOP</button>
        </ScreenMenu>
        <div class="game">
            <div class="pad"></div>
            <Screen ref='screen' :network="network" :player1="player1" :player2="player2" :cpu1="cpu1" :cpu2="cpu2" :cpu1Profile="cpu1Profile" :cpu2Profile="cpu2Profile" :onGameReady="onGameReady" :onMatchFinished="onMatchFinished" :targetScore="targetScore"></Screen>
            <div class="pad"></div>
        </div>
    </div>   
</template>

<script>
import Screen from './../components/Screen'
import ScreenMenu from './../components/ScreenMenu'

import { mapGetters } from 'vuex'

export default {
    components: {
        Screen,
        ScreenMenu,
    },
    data() {
        return {
            isReady: false,
            isNavigatingAway: false,
        }
    },
    props: {
        player1: {
            type: Object,
            default () { return { chosenName: 'Player 1'} },
        },
        player2: {
            type: Object,
            default () { return { chosenName: 'Player 2'} },
        },
    },
    computed: {
        ...mapGetters('NetworkInterface', [
            'network',
            'playing',
            'tournament',
            'currentFixture',
        ]),
        targetScore() {
            if (this.tournament && this.tournament.config && this.tournament.config.targetScore) {
                return this.tournament.config.targetScore
            }
            return 5
        },
        cpu1() {
            return this.player1 && this.player1.isBot === true
        },
        cpu2() {
            return this.player2 && this.player2.isBot === true
        },
        cpu1Profile() {
            return this.player1 && this.player1.botProfile ? this.player1.botProfile : 'normal'
        },
        cpu2Profile() {
            return this.player2 && this.player2.botProfile ? this.player2.botProfile : 'normal'
        },
    },
    watch: {
        playing(newVal) {
            console.log('Screen.vue playing changes', newVal)
            if (newVal == false) {
                this.stopGame()
            }
        },
    },
    methods: {
        isExpectedNavigationError(error) {
            if (!error) {
                return false
            }
            const ignored = ['NavigationDuplicated', 'NavigationCancelled', 'NavigationAborted', 'NavigationRedirected']
            return ignored.includes(error.name)
        },
        goToCreatedSafely() {
            if (this.isNavigatingAway) {
                return
            }
            if (this.$route && this.$route.name === this.Lobby.routes.Created.name) {
                return
            }

            this.isNavigatingAway = true
            this.$router.push({ name: this.Lobby.routes.Created.name, params: { } }).catch((error) => {
                if (!this.isExpectedNavigationError(error)) {
                    this.isNavigatingAway = false
                    throw error
                }
            })
        },
        onGameReady () {
            this.isReady = true
        },
        stopGame () {
            this.goToCreatedSafely()
        },
        onMatchFinished(result) {
            if (this.tournament && this.tournament.mode && this.tournament.mode !== 'casual') {
                const payload = {
                    ...result,
                    fixtureId: this.currentFixture ? this.currentFixture.id : null,
                    finishedAt: Date.now(),
                }
                this.$store.dispatch('NetworkInterface/reportMatchFinished', payload)
                this.goToCreatedSafely()
            }
        },

        fixDisplay() {
            // if the screen is taller than wide
            // adjust the main element to have width = height etc
            // make it absolute
            // rotate it
            
            const gameScreen = this.$refs['game-screen']
            if (!gameScreen) {
                return
            }

            if (window.innerHeight > window.innerWidth) {
                gameScreen.setAttribute('style',`position: absolute; width: ${window.innerHeight}px; height: ${window.innerWidth}px; top: 0; left: 0; transform: rotate(90deg) translate(0, -${window.innerWidth}px); transform-origin: top left;`)    
            }
            else {
                gameScreen.setAttribute('style','')
            }

            setTimeout(() => {
                if (this.$refs['screen'] && typeof this.$refs['screen'].checkDimensions === 'function') {
                    this.$refs['screen'].checkDimensions()
                }
            })
        }
    },
    beforeRouteLeave(to, from, next) {
        this.isReady = false
        if (this.$refs.screen && typeof this.$refs.screen.terminate === 'function') {
            this.$refs.screen.terminate()
        }
        next()
    },

    mounted () {
        console.log('MOUNTED ', this)
        window.addEventListener('resize', this.fixDisplay)
        if (typeof screen !== 'undefined' && screen.orientation) {
            screen.orientation.onchange = this.fixDisplay
        }
        window.addEventListener('orientationchange', this.fixDisplay)
        this.fixDisplay()
        this.$store.dispatch('NetworkInterface/startGame')
    },
    destroyed () {
        window.removeEventListener('resize', this.fixDisplay)
        if (typeof screen !== 'undefined' && screen.orientation) {
            screen.orientation.onchange = null
        }
        window.removeEventListener('orientationchange', this.fixDisplay)
        this.$store.dispatch('NetworkInterface/stopGame')
    },
}
</script>

<style lang="scss" scoped>
.game-screen {
  @import './../../../colors.scss';

  color: $main;
  height: 100vh;

  opacity: 0;
  &.ready {
    opacity: 1;
  }
  .pad {
    width: 2em;
  }   
  .game {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    height: 100%;
  }
}
.player-names {

    text-align: center;
    span {
        padding: 1em;
    }
}
</style>
